import tmhRequest from '@/config/tmhRequest'

export default {
    searchInvoiceOrderDetail: function (data) {
        return tmhRequest({
            url: '/finance/invoiceorder/searchinvoiceorderdetail',
            method: 'post',
            params: data,
        })
    },
    searchInvoiceOrderCount: function (data) {
        return tmhRequest({
            url: '/finance/invoiceorder/searchinvoiceordercount',
            method: 'post',
            data: data,
        })
    },
    searchInvoiceOrderByPage: function (data) {
        return tmhRequest({
            url: '/finance/invoiceorder/searchinvoiceorderbypage',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/order/invoiceorder.js